import React from 'react';
import { toast } from 'react-toastify';

import DeleteConfirmModal from 'components/DeleteConfirmModal';
import { useHomeScreenContext } from 'layouts/HomeScreenLayout/contexts/HomeScreenContext';
import { toastStyle } from 'utils/helper';

const DeleteBudget = () => {
  const {
    deleteBudgetMutation,
    refetchBudgets,
    refetchTabs,
    showDeleteBudget,
    hideDeleteBudgetModal,
    optimisticallyRemoveBudget,
    budgetData,
  } = useHomeScreenContext();

  const handleCancel = () => {
    hideDeleteBudgetModal();
  };

  const handleDeleteBudget = async () => {
    const budgetId = budgetData?.id;
    const rollback = optimisticallyRemoveBudget(budgetId);
    handleCancel();

    try {
      await deleteBudgetMutation.mutateAsync(budgetId);
      refetchBudgets?.();
      refetchTabs?.();
    } catch (error) {
      rollback();
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.non_field_errors?.[0];
      toast.dismiss();
      toast.error(
        message ||
          `An error occurred while deleting the budget "${budgetData?.name}". Please try again later`,
        toastStyle
      );
    }
  };

  return (
    <DeleteConfirmModal
      showModal={showDeleteBudget}
      handleOnClose={handleCancel}
      onCancel={handleCancel}
      onConfirm={handleDeleteBudget}
      confirmText={`Are you sure you want to delete this budget`}
      itemName={`"${budgetData?.name}"`}
      confirmLabel="Delete"
    />
  );
};

export default DeleteBudget;
